export const SUPPORTED_LANGUAGES = ["en", "fi"] as const;

export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = "en";
export const LANGUAGE_STORAGE_KEY = "floline.language";

export function isSupportedLanguage(value: unknown): value is AppLanguage {
  return value === "en" || value === "fi";
}

export function normalizeLanguage(value: string | null | undefined): AppLanguage {
  if (!value) {
    return DEFAULT_LANGUAGE;
  }

  const normalized = value.toLowerCase();
  if (normalized.startsWith("fi")) {
    return "fi";
  }

  return "en";
}
